import React from "react";

const PrimaryButton = React.forwardRef((props, ref) => {
    const {
        text,
        children = null,
        disabled,
        extraClasses = "",
        onClick = (e) => e,
        autoFocus = false,
        type = "submit"
    } = props;

    /* eslint-disable react/button-has-type */
    return (
        <button
            type={ type }
            ref={ ref }
            onClick={ onClick }
            className={ `form-element__primary-button ${ extraClasses }` }
            disabled={ disabled }
            autoFocus={ autoFocus }
        >
            <span className="button-label">{ text || children }</span>
        </button>
    );
    /* eslint-enable react/button-has-type */
});

export default PrimaryButton;
